import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from 'components/page/Home'
import Login from 'components/page/Login'
import Logincopy from 'components/page/Logincopy.vue'
import Alert from 'components/page/Alert'
import Conversations from "components/page/home-pages/Conversations.vue";
import groupConversation from "components/page/home-pages/groupConversation.vue";
import Integrations from "components/page/home-pages/Integrations.vue";
import Campaigns from "components/page/home-pages/Campaigns.vue";
import Templates from "components/page/home-pages/Templates.vue";
import Reporting from "components/page/home-pages/Reporting.vue";
import Settings from "components/page/home-pages/Settings.vue";
import Pipeline from "components/page/home-pages/Pipeline.vue";
import SubUserList from "components/page/home-pages/SubUserList.vue";
import Tasklist from "components/page/home-pages/Tasklist.vue";
import Dashboard from "components/page/home-pages/Dashboard.vue";
import Managers from "components/page/home-pages/Managers.vue";
import ReportingPage from "components/page/home-pages/ReportingPage.vue";
import ReportingPagev2 from "components/page/home-pages/ReportingPagev2.vue";
import Offices from "components/page/home-pages/Offices.vue";
import Importing from "components/page/home-pages/Importing.vue";
import OutOfArea from "components/page/home-pages/OutOfArea.vue";
import Assessment from "components/page/home-pages/Assessment.vue";
import AssessmentUser from "components/page/AssessmentUser.vue";
import AssessmentImport from "components/page/AssessmentImport.vue";
import HireImport from "components/page/HireImport.vue";
import MasterReport from "components/page/MasterReport";
import InterviewImport from "components/page/InterviewImport.vue";
import ChromeHeader from 'components/page/ChromeHeader'
Vue.use(VueRouter)

export default new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Login
		},
		{
			path: '/alert',
			component: Alert
		},
		{
			path: '/Login',
			component: Logincopy,
			props: route => ({
				numberSelected: route.query.numberSelected
			})
		},
		{
			path: '/assessment/:userabbr',
			component: AssessmentUser
		},
		{
			path: '/assessmentimport',
			component: AssessmentImport
		},
		{
			path: '/hireimport',
			component: HireImport
		},
		{
			path: '/MasterReport',
			component: MasterReport
		},
		{
			path: '/interviewimport',
			component: InterviewImport
		},
		{
			path: '/home',
			component: Home,
			// component: HomeCopy,
			children: [
				{
					path: '',
					redirect: 'Conversations'
				},
				{
					path: 'Dashboard',
					component: Dashboard,
				},
				{
					path: 'Pipeline',
					component: Pipeline,
				},
				{
					path: 'Conversations',
					component: Conversations,
				},
				{
                    path: 'groupConversation',
                    component: groupConversation,
                },
				{
					path: 'Integrations',
					component: Integrations,
				},
				{
					path: 'Campaigns',
					component: Campaigns,
				},
				{
					path: 'Templates',
					component: Templates,
				},
				{
					path: 'Reporting',
					component: Reporting,
				},
				{
					path: 'Settings',
					component: Settings,
				},
				{
					path: 'SubUserList',
					component: SubUserList,
				},
				{
					path: 'Tasklist',
					component: Tasklist,
				},
				{
					path: 'Managers',
					component: Managers,
				},
				{
					path: 'ReportingPage',
					component: ReportingPage,
				},
				{
					path: 'ReportingPagev2',
					component: ReportingPagev2,
				},
				{
					path: 'Offices',
					component: Offices,
				},
				{
					path: 'Importing',
					component: Importing,
				},
				{
					path: 'OutOfArea',
					component: OutOfArea,
				},
				{
					path: 'Assessment',
					component: Assessment,
				},
			],
			props: (route) => ({ page: route.path.slice(6) })
		},
		{
			path: '/chrome',
			component: ChromeHeader,
			children: [
				{
					path: '',
					redirect: 'Conversations'
				},
				{
					path: 'Dashboard',
					component: Dashboard,
				},
				{
					path: 'Pipeline',
					component: Pipeline,
				},
				{
					path: 'Conversations',
					component: Conversations,
				},
				{
                    path: 'groupConversation',
                    component: groupConversation,
                },
				{
					path: 'Integrations',
					component: Integrations,
				},
				{
					path: 'Campaigns',
					component: Campaigns,
				},
				{
					path: 'Templates',
					component: Templates,
				},
				{
					path: 'Reporting',
					component: Reporting,
				},
				{
					path: 'Settings',
					component: Settings,
				},
				{
					path: 'SubUserList',
					component: SubUserList,
				},
				{
					path: 'Tasklist',
					component: Tasklist,
				},
				{
					path: 'Managers',
					component: Managers,
				},
				{
					path: 'ReportingPage',
					component: ReportingPage,
				},
				{
					path: 'ReportingPagev2',
					component: ReportingPagev2,
				},
				{
					path: 'Offices',
					component: Offices,
				},
				{
					path: 'Importing',
					component: Importing,
				},
				{
					path: 'OutOfArea',
					component: OutOfArea,
				},
				{
					path: 'Assessment',
					component: Assessment,
				}
			],
			props: (route) => ({ page: route.path.slice(6) })
		},
	]
})
